module.exports = __webpack_public_path__ + "static/media/no-results.74f811d8.svg";